import { Component } from '@angular/core';
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';

/**
 * Generated class for the PopupWaiterReportSales page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-popup-waiter-report-sales',
  templateUrl: 'popup-waiter-report-sales.html',
})
export class PopupWaiterReportSales {
  waiter: any;
  public firestore: any;


  constructor(
    public globals: Globals,
    public translate: TranslateService,
    public viewCtrl: ViewController,
    public navCtrl: NavController,
    public navParams: NavParams,) {
    this.waiter = this.navParams.get('waiter');
  }

  close() {
    this.viewCtrl.dismiss();
  }

  styleCard(index) {
    var styles;

    if (index % 2 == 0) {
      styles = {
        'background-color': '#fff',
      }
    } else {
      styles = {
        'background-color': 'rgba(0, 0, 0, 0.05)',
      }
    }
    return styles;
  }

}



// WEBPACK FOOTER //
// ./src/pages/components/popups/popup-waiter-report-sales/popup-waiter-report-sales.ts